import { styled, Theme } from '@mui/material';

export const sxStyles = {
  sectionBg: (theme: Theme) => ({
    backgroundColor: theme.palette.common.white,
    padding: '3rem 0',
  }),
  header: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '1rem',
    marginBottom: '2rem',
  },
  title: (theme: Theme) => ({
    color: theme.palette.primary.main,
  }),
  group: {
    marginBottom: '2rem',
  },
  groupTitle: {
    marginBottom: '1rem',
  },
  chip: {
    cursor: 'pointer',
  },
  toggle: {
    display: 'flex',
    margin: '0 auto',
  },
};

export const StyledSchoolsGrid = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '2rem',

  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}));
